import React, { useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import Card from '../atoms/Card';
import Message, { StatusMessageType } from '../atoms/Message';

function handleConfirmUnsubscribe (
  subscriptionId: string,
  setStatusMessage: (statusMessage: StatusMessageType) => void,
  setIsUnsubscribing: (isUnsubscribing: boolean) => void,
  setUnsubscribeSuccess: (unsubscribeSuccess: boolean) => void,
) {
  axios
    .post(
      '/apis/microsoft/subscriptions/unsubscribe/',
      {
        subscriptionId,
      },
    )
    .then(
      (res: AxiosResponse) => {
        if (res.data.status === 'OK') {
          setStatusMessage({
            type: 'success',
            message: 'Subscription was unsubscribed. Please allow a few minutes before the change takes effect.',
          });
          setIsUnsubscribing(false);
          setUnsubscribeSuccess(true);
        } else {
          setStatusMessage({
            type: 'warning',
            message: res.data.message,
          });
        }
        setIsUnsubscribing(false);
      },
      (reason:any) => {
        setStatusMessage({
          type: 'error',
          message: reason,
        });
        setIsUnsubscribing(false);
      },
    );
}

const UnsubscribeCard = ({
  subscriptionId,
}: {
  subscriptionId: string;
}): JSX.Element => {
  const [isUnsubscribing, setIsUnsubscribing] = useState(false);
  const [unsubscribeSuccess, setUnsubscribeSuccess] = useState(false);
  const [statusMessage, setStatusMessage] = useState<StatusMessageType>();
  
  return (
    <>
      {
        !isUnsubscribing
          ? <button
              type="button"
              className="my-2 mr-2"
              onClick={
                () => {
                  setIsUnsubscribing(true);
                }
              }
              disabled={unsubscribeSuccess}
            >
              {
                unsubscribeSuccess
                  ? 'Unsubscribed Successfully'
                  : 'Unsubscribe'
              }
            </button>
          : <Card theme="dark" className="mb-4">
              <h2 className="mt-0">Are you sure you want to unsubscribe?</h2>
              <div>This action cannot be undone.</div>
              <button
                className="mr-2 mb-0"
                type="button"
                onClick={
                  () => {
                    handleConfirmUnsubscribe(
                      subscriptionId,
                      setStatusMessage,
                      setIsUnsubscribing,
                      setUnsubscribeSuccess
                    );
                  }
                }
              >
                Confirm Unsubscribe
              </button>
              <button
                className="mr-2 mb-0"
                type="button"
                onClick={
                  () => {
                    setIsUnsubscribing(false);
                  }
                }
              >
                Cancel
              </button>
            </Card>
      }
      {
        statusMessage &&
          <Message
            theme="dark"
            type={statusMessage.type}
          >
            {statusMessage.message}
          </Message>
      }
    </>
  );
};

export default UnsubscribeCard;
